export default __webpack_public_path__ + "static/media/f_5.cd298edb.jpg";